import { trigger, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { faMessageSlash } from '@fortawesome/pro-solid-svg-icons';

import { AiChatState, Question, QuestionType } from '@empathy/survey/base';

@Component({
  selector: 'empathy-question-view',
  templateUrl: 'question-view.component.html',
  styleUrls: ['./question-view.component.scss', './_question-view-theme.component.scss'],
  animations: [trigger('swapQuestion', [transition(':enter', [style({ opacity: 0 }), animate('150ms ease-in')])])]
})
export class QuestionViewComponent {
  @Input() question: Question;
  @Input() questionCtrl: FormControl | FormArray | FormGroup;
  @Input() chatState?: AiChatState;
  @Input() previewMode = false;

  @Output() forceStop = new EventEmitter<boolean>();
  @Output() httpError = new EventEmitter<void>();

  readonly faMessageSlash = faMessageSlash;

  fullSizeQuestions = [QuestionType.AIChat];
  noStimulusQuestions = [QuestionType.AIChat];

  questionType = QuestionType;
}
